import React, { Component } from "react";
import {marked} from "marked";
import privacyFile from "../resources/docs/privacy.md"
import CircularLoadingScreen from "./commons/CircularLoadingScreen";
import { withSnackbar } from '../hocs/withSnackbar';

class PrivacyPolicy extends Component {
  state = { loadedMarkdown: false, markdown: "" };

  async componentDidMount() {
    try{
        const privacy = await fetch(privacyFile);
        const contents = await privacy.text()
        this.setState({
            loadedMarkdown: true,
            markdown: marked(contents)
        })
    } catch (error){
        this.props.showMessage("An error occurred while loading page. If this error persists, contact us.", "error", 10000)
    }
  }

  render() {
    const { loadedMarkdown, markdown } = this.state;
    if (!loadedMarkdown) {
      return <CircularLoadingScreen thickness={5} />;
    }
    return (
      <div style={{
        width: '70%',
        margin: 'auto',
        paddingBottom: 30
      }}>
        <h1 className="heading">Privacy Policy</h1>
        <div dangerouslySetInnerHTML={{ __html: markdown }}></div>
      </div>
    );
  }
}

export default withSnackbar(PrivacyPolicy);
